import React from 'react';
import { useNavigate } from 'react-router-dom';
import { translate } from '../../../Services/translation';
import { breakpoint } from '../../../styling/mixins/breakpoints';
import styled from 'styled-components';
import { getColor } from '../../../styling/mixins/colors';
import { fontFamilyBold, text } from '../../../styling/mixins/typography';
import { cells, grid } from '../../../styling/utils/grid';
import Button from '../../Button';

const StyledOrderMobileItemOmnium = styled.li`
  padding: 1.6rem;
  border: 1px solid ${getColor('grey', 300)};
  border-radius: 4px;
  margin-bottom: 1.6rem;
  background-color: ${getColor('white')};

  .title {
    ${text('large')}
    ${fontFamilyBold}
    margin-bottom: 1.2rem;
  }

  .sub-title {
    ${text('small')}
    text-transform: uppercase;
    color: ${getColor('grey', 600)};
  }

  .ordernumber {
    padding-bottom: 1rem;
  }

  .span {
    ${text('medium')}
  }

  .content {
    ${grid}
    ${cells(2)}
    ${breakpoint('medium')} {
      ${cells(5)}
    }
  }

  .content__cell {
    display: flex;
    flex-direction: column;
  }

  .btn--read-more {
    grid-column: span 2;
    margin-top: 1.2rem;
    ${fontFamilyBold}

    ${breakpoint('medium')} {
      grid-column: unset;
      margin-top: 0;
    }
  }
`;

const OrderListItemMobileOmnium = ({
  order,
  onClick,
  showTrackingNumber,
}) => {
  return (
    <StyledOrderMobileItemOmnium>
      <div>
        <p className="title">
          {translate('orderlist.column.ordernumber')}: {order.orderNumber}
        </p>
        {showTrackingNumber && (
          <p className="sub-title ordernumber">
            {translate('orderlist.column.trackingnumber')}:{' '}
            {order.shipments.map((shipment, index) => (
              <span key={index}>
                {shipment.trackingLink ? (
                  <a
                    href={shipment.trackingLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline"
                  >
                    {shipment.trackingNumber}
                  </a>
                ) : (
                  shipment.trackingNumber
                )}
                {index < order.shipments.length - 1 && ', '}
              </span>
            ))}
          </p>
        )}
      </div>
      <div className="content">
        <div className="content__cell">
          <p className="sub-title">
            {translate('orderlist.column.quantity')}
          </p>
          <p className="span">{order.orderItemsCount}</p>
        </div>
        <div className="content__cell">
          <p className="sub-title">
            {translate('orderlist.column.grandtotal')}
          </p>
          <p className="span">{order.orderTotalInclVat}</p>
        </div>
        <div className="content__cell">
          <p className="sub-title">
            {translate('orderlist.column.orderdate')}
          </p>
          <p className="span">{order.placedDate}</p>
        </div>
        <div className="content__cell">
          <p className="sub-title">
            {translate('orderlist.column.status')}
          </p>
          <p className="span">{order.status}</p>
        </div>
        <Button
          btnType="outlined"
          btnSize="small"
          onClick={() => onClick && onClick(order)}
          className="btn--read-more"
        >
          {translate('orderlist.column.readmore')}
        </Button>
      </div>
    </StyledOrderMobileItemOmnium>
  );
};

export default OrderListItemMobileOmnium;
